<template>
  <div>
    <el-row>
      <el-col :span="12" class="px-2">
        <el-card shadow="hover">
          <span style="color:gray; font-weight:bold;">{{ `${$t("AdvShopStat.Advanced_Charts")}：${shopName}` }}</span>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <!-- Side navigation -->
      <el-col :span="6" class="p-2">
        
        <el-menu :default-active="navIndex" @select="onNavigationItemSelected">
          <el-menu-item index="1">
            {{ `${$t("AdvShopStat.Member_Visits")}/${$t("AdvShopStat.Order_Frequency_Distribution")}` }}
          </el-menu-item>
          <el-menu-item index="2">
            {{ $t("AdvShopStat.New_Member_Trends_Chart") }}
          </el-menu-item>
          <el-menu-item index="3">
            {{ $t("AdvShopStat.Member_Order_Frequency_Ranking") }}
          </el-menu-item>
        </el-menu>

      </el-col>

      <!-- Chart content -->
      <el-col :span="18" class="p-2">
        <el-card shadow="hover">

          <!-- Date-time picker -->
          <el-date-picker :key="appLang" type="daterange" v-model="pickedDates"
            range-separator="～" :start-placeholder="$t('AdvShopStat.Start_Time')" :end-placeholder="$t('AdvShopStat.End_Time')"
            :picker-options="datePickerOptions"
            @change="onDateRangeChanged">
          </el-date-picker>

          <!-- Chart or tabls -->
          <div>
            <div class="py-4" v-if="mode == 'chart'">
              <component :is="chart.type" :height="220"
                :chart-data="chart.data"
                :options="chart.options || trendChartOptions">
              </component>
            </div>

            <div class="py-4" v-else>
              <data-tables
                :data="rows"
                :pagination-props="{pageSizes: [5, 10, 50]}"
                :table-props="tableProps">
                <!-- <el-table-column prop="picture_url" label=" " width="120" align="center" v-if="cheatMode">
                  <template slot-scope="{row}">
                    <img :src="row.picture_url" alt="...">
                  </template>
                </el-table-column> -->
                <el-table-column prop="name" :label="$t('AdvShopStat.Order_Placer')" width="240">
                  <template slot-scope="{row}">
                    {{ row.name }}
                  </template>
                </el-table-column>
                <el-table-column prop="phone" :label="$t('AdvShopStat.Phone')">
                  <template slot-scope="{row}">
                    {{ twnPhoneFormat(row.phone) }}
                  </template>
                </el-table-column>
                <el-table-column prop="order_count" :label="$t('AdvShopStat.Order_Count')" width="120" sortable="custom">
                </el-table-column>
              </data-tables>
            </div>
          </div>
          
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import TrendChart from 'src/components/Charts/TrendChart';
import LineChart from 'src/components/Charts/LineChart';
import Chart from 'chart.js';
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels';
import { mapGetters } from 'vuex';

import { DataTables } from "vue-data-tables";

import { UserInfoMixin } from 'src/mixins/user-info.js';

import axios from 'axios';
import moment from 'moment';

export default {
  components: {
    TrendChart, LineChart,
    ChartJSPluginDatalabels,

    DataTables
  },
  mixins: [ UserInfoMixin ],

  mounted() {
    console.log(`Advanced chart page mounted. Shop ID is ${this.shopId}`);
    this.renderChart();
  },

  methods: {
    onNavigationItemSelected(_index) {
      this.navIndex = _index;
      this.renderChart();
    },

    onDateRangeChanged() {
      this.renderChart();
    },

    renderChart() {
      let api = `${process.env.VUE_APP_APIHOST}/${this.userType}/shops/${this.shopId}`;
      let from = moment(this.pickedDates[0]).startOf('day').unix(),
        to = moment(this.pickedDates[1]).endOf('day').unix();

      switch (this.navIndex) {
        // Distribution of user-count against visit-count. 
        case '1': {
          this.mode = 'chart';
          this.chart.type = 'trend-chart';
          axios.get(`${api}/adv/visit-count?from=${from}&to=${to}`)
          .then(response => {
            let data = response.data;
            let labels = _pluck(data, 'numOfVisits').map(l => this.$t('AdvShopStat.Order_Times', { num: l}));
            let numbers = [];
            data.forEach(d => { numbers.push(d['userCount']); });
            
            this.chart.data = {
              labels: labels, datasets: [ { label: this.$t('AdvShopStat.Order_Frequency_Distribution'), data: numbers } ]
            };
            this.chart.options = {
              scales: {
                yAxes: [
                  {
                    ticks: { min: 0, precision: 0 },
                    scaleLabel: { display: true, labelString: this.$t('AdvShopStat.Number_Of_People') }
                  }
                ]
              }
            };
          });
          break;
        }
        //TODO: ???
        case '2': {
          this.mode = 'chart';
          this.chart.type = 'line-chart';
          axios.get(`${api}/adv/first-visit?from=${from}&to=${to}`)
          .then(response => {
            let data = response.data;
            console.log(data);
            let labels = _pluck(data, 'date');
            let numbers = [];
            data.forEach(d => { numbers.push(d['firstVisitCount']); });
            
            this.chart.data = {
              labels: labels, datasets: [ { label: this.$t('AdvShopStat.Message.First_Time_Buyer_Distrution'), data: numbers, lineTension: 0 } ]
            };
            this.chart.options = {
              scales: {
                yAxes: [
                  {
                    ticks: { min: 0, precision: 0 },
                    scaleLabel: { display: true, labelString: this.$t('AdvShopStat.Number_Of_First_Time_Order_Users') }
                  }
                ]
              }
            };
          });
          break;
        }
        case '3': {
          this.mode = 'table';
          axios.get(`${api}/adv/user-ranking?from=${from}&to=${to}`)
          .then(response => {
            this.rows = response.data;
          });
          break;
        }
        default:
      }
    }
  },

  data() {
    return {
      navIndex: '1', mode: 'chart',
      pickedDates: [
        moment().startOf('month').toDate(),
        new Date()
      ],

      chart: {
        type: 'trend-chart',
        data: {labels: [], datasets: [{data: []}]},
        options: this.trendChartOptions
      },

      // Chart settings
      trendChartOptions: {
        layout: {padding: {left: 24, right: 24}},
        scales: {
          xAxes: [{barPercentage: 1, categoryPercentage: 0.8, stacked: true}],
          yAxes: [
            {ticks: {min: 0, precision: 0}}
          ]
        }
      },

      // Data-table attributes
      rows: [],
      tableProps: {
        // defaultSort: {
        //   prop: 'qty',
        //   order: 'descending'
        // }
      }
    };
  },

  computed: {
    ...mapGetters([
      'appLang',
    ]),
    datePickerOptions() {
      const shortcuts = [{
        text: this.$t("AdvShopStat.This_Week"),
        onClick(picker) {
          picker.$emit('pick', [
            moment().startOf('isoWeek').toDate(),
            moment().endOf('day').toDate()
          ]);
        }
      }, {
        text: this.$t("AdvShopStat.This_Month"),
        onClick(picker) {
          picker.$emit('pick', [
            moment().startOf('month').toDate(),
            moment().endOf('day').toDate()
          ]);
        }
      }, {
        text: this.$t("AdvShopStat.Last_Month"),
        onClick(picker) {
          picker.$emit('pick', [
            moment().add(-1, 'months').startOf('month').toDate(),
            moment().add(-1, 'months').endOf('month').toDate()
          ]);
        }
      }]
      return { shortcuts }
    },
    shopId() {
      return this.$route.query.shopId || this.$route.params.shopId;
    },
    shopName() {
      return this.$route.query.shopName || this.$route.params.shopName;
    },

    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType;
    },
    // cheatMode() {
    //   return this.$store.getters.cheatMode;
    // }
  },

  watch: {
    appLang: {
      handler(newVal, oldVal) {
        if (!newVal) return;
        // 重新繪製
        this.renderChart();
      },
    },
  }
}

function _pluck(arr, key) {
  let ret = [];
  for (let i=0; i<arr.length; i++) 
    ret.push(arr[i][key]);
  return ret;
}
</script>

<style scoped>

</style>